import styled from 'styled-components';


export const StyledHomeMap = styled.div` 
  min-height: 350px;
  height: 100%;

  .home-map-container {
    top: -1px;
    min-height: 350px;
    height: 100%;
    padding: 0px;
    position: relative;
  }
`;



// WEBPACK FOOTER //
// ./src/components/OfficesMap/styles/StyledHomeMap.js